module.exports = __webpack_public_path__ + "static/media/options.08e5601c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/options.svg
// module id = 955
// module chunks = 5